import { injectIntl, WrappedComponentProps, useIntl } from 'react-intl';
import { compose, setDisplayName, setPropTypes, withPropsOnChange } from 'recompose';
import { MediaManagerSDKFolder } from '../../media-manager-sdk';
import { getRootFolderBySource } from '../../media-manager-sdk/root-folder';
import { useMMGRSettings, withMMGRSettings, withoutMMGRSettings } from '../withMMGRSettings';
import { IMMGRSettingsProps } from '../withMMGRSettings/withMMGRSettings.types';
import { IWithRootFolderInner, IWithRootFolderOuter } from './withRootFolder.types';
import { string } from 'prop-types';
import { ejectIntl } from '../ejectIntl';
import { Source } from '../../../constants/Source';
import { useMemo } from 'react';

/**
 * @deprecated as we are moving from HOCs to hooks, please use `useRootFolder` if possible
 */
export const withRootFolder = compose<IWithRootFolderInner, IWithRootFolderOuter>(
  setPropTypes({
    source: string.isRequired,
  }),
  setDisplayName('withRootFolder'),
  withMMGRSettings,
  injectIntl,
  withPropsOnChange<IWithRootFolderInner, IWithRootFolderOuter & WrappedComponentProps & IMMGRSettingsProps>(
    ['source'],
    ({ source, intl: { formatMessage }, mmgrSettings }) => ({
      rootFolder: getRootFolderBySource(source, formatMessage, mmgrSettings),
    }),
  ),
  ejectIntl,
  withoutMMGRSettings,
);

export const useRootFolder = (source: Source): MediaManagerSDKFolder => {
  const { formatMessage } = useIntl();
  const { mmgrSettings } = useMMGRSettings();
  return useMemo(
    () => getRootFolderBySource(source, formatMessage, mmgrSettings),
    [source, formatMessage, mmgrSettings.isSecureContext, mmgrSettings.namespace],
  );
};
